module.exports = __webpack_public_path__ + "img/scount-middle.d0598f49.svg";